import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ToastComponent } from '../layout/toast/toast.component';
import { SpinnerComponent } from '../layout/spinner/spinner.component';

/**
 * 共用元件模組 — 供 lazy loading 的 feature module 與既有 comm.module 共用。
 * 目前抽出 Toast / Spinner（pilot 頁 employee-auth 需要）。
 * 之後可逐步把 table-v2、pagnation 等其他共用元件搬進來。
 */
@NgModule({
  declarations: [ToastComponent, SpinnerComponent],
  imports: [CommonModule, FormsModule],
  exports: [ToastComponent, SpinnerComponent, CommonModule, FormsModule],
})
export class SharedModule {}
